<div class="raise-request">
  <emerald-modal
    [opened]="opened"
    [headerText]="title"
    [closeOnOutsideClick]="false"
    (onDismiss)="updateActions(false)"
  >
    <ng-container *ngIf="!candidatesLoading">
      <div class="position-details">
        <ng-container *ngIf="fieldsVisibility === 'VENDORREPOPENPOS'">
          <div class="info">
            Position Applied : <span class="span-info">{{ jobTitle }}</span>
          </div>
          <div class="info">
            Location : <span class="span-info">{{ jobLocation }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="fieldsVisibility === 'VENDORREPJOBDET'">
          <div class="info">
            Position Applied :
            <span class="span-info">{{ candidatesDetail?.jobTitle }}</span>
          </div>
          <div class="info">
            Location :
            <span class="span-info">{{ candidatesDetail?.location }}</span>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="openForm">
        <form [formGroup]="addCandidateForm">
          <div class="add-candidate">
            <emerald-input
              [label]="'Name'"
              [outlined]="true"
              [isValid]="isFieldValid('candidateName')"
              [errorText]="getFieldError('candidateName')"
              [value]="candidatesDetail?.candidateName"
              formControlName="candidateName"
            ></emerald-input>
            <div>
              <emerald-input
                [label]="'Total Experience'"
                [outlined]="true"
                [isValid]="isFieldValid('yearsOfExperience')"
                [errorText]="getFieldError('yearsOfExperience')"
                [value]="candidatesDetail?.yearsOfExperience"
                formControlName="yearsOfExperience"
                (input)="handleFieldChange($event, 'yearsOfExperience')"
              ></emerald-input>
              <div
                class="field-error"
                *ngIf="addCandidateForm.get('yearsOfExperience')?.invalid"
              >
                <span
                  class="field-error-message"
                  *ngIf="
                    addCandidateForm.get('yearsOfExperience')?.errors?.[
                      'maxOverallExperience'
                    ] ||
                    addCandidateForm.get('overAllExp')?.errors?.[
                      'negativeValue'
                    ]
                  "
                >
                  {{ hiringRequestText.overallExperienceError }}
                </span>
              </div>
            </div>
            <div>
              <emerald-input
                [label]="'Relevant Experience'"
                [outlined]="true"
                [isValid]="isFieldValid('yearsOfRelevantExperience')"
                [value]="candidatesDetail?.yearsOfRelevantExperience"
                [errorText]="getFieldError('yearsOfRelevantExperience')"
                formControlName="yearsOfRelevantExperience"
                (input)="handleFieldChange($event, 'yearsOfRelevantExperience')"
              ></emerald-input>
              <div
                class="field-error"
                *ngIf="
                  addCandidateForm.get('yearsOfExperience')?.invalid ||
                  addCandidateForm.get('yearsOfRelevantExperience')?.invalid
                "
              >
                <span
                  class="field-error-message"
                  *ngIf="
                    addCandidateForm.get('yearsOfRelevantExperience')?.errors?.[
                      'maxOverallExperience'
                    ] ||
                    addCandidateForm.get('yearsOfRelevantExperience')?.errors?.[
                      'negativeValue'
                    ]
                  "
                >
                  {{ hiringRequestText.overallExperienceError }}
                </span>
                <span
                  class="field-error-message"
                  *ngIf="
                    addCandidateForm.get('yearsOfRelevantExperience')?.errors?.[
                      'relevantExperienceExceeds'
                    ]
                  "
                >
                  {{ hiringRequestText.relevantExperienceError }}
                </span>
              </div>
            </div>

            <emerald-dropdown
              [options]="locationOptions"
              [id]="'multi_select'"
              [label]="'Location'"
              [outlined]="true"
              [isValid]="isFieldValid('location')"
              [errorText]="getFieldError('location')"
              formControlName="location"
              preSelectedLabel="' '"
              preSelectedValue="' '"
            ></emerald-dropdown>
            <emerald-dropdown
              [options]="mandatorySkillOptions"
              [id]="'multi_select'"
              [label]="'Primary Skills'"
              [outlined]="true"
              [multiSelect]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('primarySkills')"
              [errorText]="getFieldError('primarySkills')"
              formControlName="primarySkills"
              (change)="onPrimarySkillsChange()"
            >
            </emerald-dropdown>
            <emerald-dropdown
              class="ac-optional"
              [options]="gthSkillOptions"
              [id]="'multi_select'"
              [label]="'Secondary Skills'"
              [outlined]="true"
              [multiSelect]="true"
              [showFilter]="true"
              formControlName="secondarySkills"
              [errorText]="getFieldError('primarySkills')"
              (change)="onSecondarySkillsChange()"
            >
            </emerald-dropdown>
            <div>
              <emerald-input
                [label]="'Contact Number'"
                [outlined]="true"
                [isValid]="isFieldValid('contactNumber')"
                [errorText]="getFieldError('contactNumber')"
                [maxLength]="maxLengthTen"
                [value]="candidatesDetail?.contactNumber"
                formControlName="contactNumber"
                (input)="validateContactNumber($event)"
              >
              </emerald-input>

              <div
                class="field-error"
                *ngIf="addCandidateForm.get('contactNumber')?.invalid"
              >
                <span
                  class="field-error-message"
                  *ngIf="
                    addCandidateForm.get('contactNumber')?.errors?.['onlyZeros']
                  "
                >
                  Contact number can't be only zeros.
                </span>
              </div>
            </div>
            <div>
              <emerald-input
                [label]="'URL'"
                [outlined]="true"
                [trailingIcon]="'link'"
                [isValid]="isFieldValid('url')"
                [errorText]="getFieldError('url')"
                [value]="candidatesDetail?.url"
                formControlName="url"
              ></emerald-input>
            </div>
            <emerald-input
              [label]="'Email ID'"
              [outlined]="true"
              [isValid]="isFieldValid('emailId')"
              [errorText]="getFieldError('emailId')"
              [value]="candidatesDetail?.emailId"
              formControlName="emailId"
            ></emerald-input>
            <div>
              <emerald-datepicker
                [label]="'Tentative DOJ'"
                [minDate]="currentDate"
                [isOutlined]="true"
                [forceRefresh]="true"
                [keepInvalid]="isFieldValid('earliestAvailability')"
                [required]="true"
                formControlName="earliestAvailability"
                (keydown)="preventInvalidKeyPress($event)"
              ></emerald-datepicker>
              <div
                class="field-error"
                *ngIf="
                  isSubmitted &&
                  addCandidateForm.get('earliestAvailability')?.invalid
                "
              >
                <span
                  class="field-error-message"
                  *ngIf="
                    addCandidateForm.get('earliestAvailability')?.errors?.[
                      'required'
                    ]
                  "
                  >Please choose the tentative date of joining.</span
                >
              </div>
            </div>
            <div class="resume-upload-input">
              <span class="ac-up-label">Resume Upload <em>*</em></span>
              <div
                class="ac-dropzone"
                [class.drag]="dragResume"
                (click)="fileUpload.click()"
                (dragover)="onDragOver($event, 'resume')"
                (dragleave)="onDragLeave($event, 'resume')"
                (drop)="onDropResume($event)"
              >
                <emerald-icon class="ac-dz-icon">cloud_upload</emerald-icon>
                <div class="ac-dz-text"><b>Click to upload</b> or drag &amp; drop</div>
                <div class="ac-dz-hint">PDF or Word · up to 10 MB</div>
              </div>
              <input type="text" formControlName="resumePath" class="ac-hidden-control" tabindex="-1" aria-hidden="true" />
              <div class="upload-container">
                <input
                  type="file"
                  id="file-upload"
                  class="file-input"
                  (change)="onFileSelected($event)"
                  #fileUpload
                />
                <div
                  *ngIf="selectedFile || candidatesDetail?.resumePath"
                  class="selected-file"
                >
                  <emerald-icon [icon]="'insert_drive_file'"></emerald-icon>
                  <div class="file-info">
                    <span class="file-name" *ngIf="selectedFile">{{
                      selectedFile
                    }}</span>
                    <span class="file-name" *ngIf="!selectedFile">{{
                      selectedFile
                    }}</span>
                    <emerald-icon
                      [icon]="'check_circle'"
                      class="status-icon"
                    ></emerald-icon>
                    <span class="file-size">{{ fileSize }}</span>
                  </div>
                  <emerald-icon
                    [icon]="'delete'"
                    (click)="onDeleteFile()"
                  ></emerald-icon>
                </div>
                <div
                  class="field-error"
                  *ngIf="isSubmitted || resumeFileError"
                >
                  <span
                    class="field-error-message"
                    *ngIf="
                      addCandidateForm.get('resumePath')?.errors?.['required']
                    "
                    >Please upload a resume.</span
                  >
                  <span class="field-error-message" *ngIf="resumeFileError">
                    {{ resumeFileError }}
                  </span>
                </div>
              </div>
            </div>
            <div class="resume-upload-input">
              <span class="ac-up-label">Initial Screening Feedback <em>*</em></span>
              <div
                class="ac-dropzone"
                [class.drag]="dragDocs"
                (click)="extraFileUpload.click()"
                (dragover)="onDragOver($event, 'docs')"
                (dragleave)="onDragLeave($event, 'docs')"
                (drop)="onDropDocs($event)"
              >
                <emerald-icon class="ac-dz-icon">cloud_upload</emerald-icon>
                <div class="ac-dz-text"><b>Click to upload</b> or drag &amp; drop</div>
                <div class="ac-dz-hint">PDF or Word · up to 10 MB</div>
              </div>
              <input type="text" formControlName="additionalDocumentsPath" class="ac-hidden-control" tabindex="-1" aria-hidden="true" />
              <div class="upload-container">
                <input
                  type="file"
                  id="file-uploads"
                  class="file-input"
                  (change)="onAdditilalFile($event)"
                  #extraFileUpload
                />
                <div
                  *ngIf="
                    selectedAddFile || candidatesDetail?.additionalDocumentsPath
                  "
                  class="selected-file"
                >
                  <emerald-icon [icon]="'insert_drive_file'"></emerald-icon>
                  <div class="file-info">
                    <span class="file-name" *ngIf="selectedAddFile">{{
                      selectedAddFile
                    }}</span>
                    <span class="file-name" *ngIf="!selectedAddFile">{{
                      selectedAddFile
                    }}</span>
                    <emerald-icon [icon]="'check_circle'"></emerald-icon>
                    <span class="file-size">{{ fileSize }}</span>
                  </div>
                  <emerald-icon
                    [icon]="'delete'"
                    (click)="onDeleteAdditionalFile()"
                  ></emerald-icon>
                </div>
                <div
                  class="field-error"
                  *ngIf="isSubmitted || additionalFileError"
                >
                  <span
                    class="field-error-message"
                    *ngIf="
                      addCandidateForm.get('additionalDocumentsPath')?.errors?.[
                        'required'
                      ]
                    "
                    >Please upload the screening feedback.</span
                  >
                  <span class="field-error-message" *ngIf="additionalFileError">
                    {{ additionalFileError }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!candidatesLoading" actions>
      <span class="mdc-dialog__button">
        <emerald-button
          [type]="'Secondary'"
          color="primary"
          (click)="onCancel()"
          label="Cancel"
        >
        </emerald-button>
      </span>
      <span class="mdc-dialog__button">
        <emerald-button [type]="'Primary'" (onClick)="submit()" label="Save">
          Submit
        </emerald-button>
      </span>
    </ng-container>
  </emerald-modal>

  <ng-template #duplicateDialog>
    <div class="status-change-dialog">
      <div class="dialog-content">
        <div class="employee-message">
          <p>{{ duplicateMessage }}</p>
        </div>
        <div *ngIf="duplicateSubmissions?.length">
          <div class="duplicate-list">
            <div class="duplicate-row header">
              <div>Job ID</div>
              <div title="Job Title">Job Title</div>
              <div title="Hiring Manager">Hiring Manager</div>
              <div title="Status">Status</div>
              <div title="Feedback">Feedback</div>
              <div title="Vendor">Vendor</div>
              <div title="Submitted Date">Submitted</div>
            </div>
            <div class="duplicate-row" *ngFor="let duplicateSubmission of duplicateSubmissions">
              <div>
                {{ duplicateSubmission.jobId }}
              </div>
              <div [title]="getTooltipText(duplicateSubmission.jobTitle)">
                {{ truncateText(duplicateSubmission.jobTitle, 20) }}
              </div>
              <div [title]="getTooltipText(duplicateSubmission.hiringManager || '')">
                {{ truncateText(duplicateSubmission.hiringManager || '', 20) }}
              </div>
              <div [title]="getTooltipText(duplicateSubmission.status || '')">
                {{ truncateText(duplicateSubmission.status || '', 15) }}
              </div>
              <div [title]="getTooltipText(duplicateSubmission.feedback || '')">
                {{ truncateText(duplicateSubmission.feedback || '', 30) }}
              </div>
              <div [title]="getTooltipText(duplicateSubmission.vendorName || '')">
                {{ truncateText(duplicateSubmission.vendorName || '', 20) }}
              </div>
              <div [title]="getTooltipText((duplicateSubmission.submittedDate | date: 'medium') || '')">
                {{ truncateText((duplicateSubmission.submittedDate | date: 'medium') || '', 20) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-actions">
        <emerald-button
          [label]="'Continue'"
          [type]="'Primary'"
          (onClick)="overrideAndSubmit()">
        </emerald-button>
        <emerald-button
          [label]="'Cancel'"
          [type]="'Secondary'"
          (onClick)="closeDuplicateDialog()">
        </emerald-button>
      </div>
    </div>
  </ng-template>
</div>
